import { atom } from 'jotai';

export const uiTourRefsAtom = atom<Record<string, HTMLElement | null>>({});
